<div class="_relative">
    <app-placeholder-card
            *ngFor="let e of [].constructor(placeholderCards); let i = index"
            [useAvatarPlaceholder]="useAvatarPlaceholder">
    </app-placeholder-card>
    <div *ngIf="intoBoxMessage" class="message-info-box _shadow">
        <span>{{ intoBoxMessage }}</span>
        <ng-content></ng-content>
    </div>
</div>

